import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { useLang } from "@/context/Lang";

function Counter({ value }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    const match = value.match(/^([\d.]+)/);
    if (!match) { setDisplay(value); return; }
    if (!inView) return;
    const target = parseFloat(match[1]);
    const suffix = value.slice(match[1].length);
    const decimals = match[1].includes(".") ? 1 : 0;
    let start = 0;
    const dur = 1400;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const cur = (start + (target - start) * eased).toFixed(decimals);
      setDisplay(cur + suffix);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  return <span ref={ref}>{display}</span>;
}

export default function SocialProof() {
  const { t } = useLang();
  return (
    <section className="bg-navy grain relative" data-testid="social-proof">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20 grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6">
        {t.proof.map((p, i) => (
          <div key={i} className="text-center lg:text-left lg:border-l lg:border-white/10 lg:pl-6" data-testid={`proof-${i}`}>
            <div className="font-display font-black text-white text-4xl md:text-6xl tracking-tighter">
              <Counter value={p.n} />
            </div>
            <div className="mt-2 text-white/55 text-sm md:text-base font-medium">{p.l}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
